import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function HR_FAQ_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='mt-5'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-5'>Why are you interested in a human resources role?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          Human resources are about supporting employees and businesses in an enterprise. I like to be at the heart of the enterprise in this way. Looking at the different corporate functions in an enterprise, I feel that an HR role is the best starting place for me to learn.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>What interpersonal skills are important in this role?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          In human resources, you’ll work with company leaders, peers, and team members as well as third parties. Excellent communication skills, the ability to express your opinions diplomatically, and patience are key skills in this role.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-5'>What is Deep Learning, and how is it used in real-world?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          I imagine that to track employee data efficiently, every HR department uses a database of some type. I haven’t had the opportunity to use any of these systems so far. I look forward to learning about how they make an HR department more efficient.
          </Typography>
        </AccordionDetails>
      </Accordion>

    </div>
    </div>
  );
}
